export default __webpack_public_path__ + "static/media/les_downarrow.bd60c379.svg";